import { Builder } from '@builder.io/sdk';
import { ALL_EXPERTS_COMPONENT_NAME, AllExperts } from './AllExperts';

const allExpertsConfig = {
  name: ALL_EXPERTS_COMPONENT_NAME,
  inputs: [
    {
      name: 'heading',
      type: 'string',
      required: true,
    },
    {
      name: 'body',
      type: 'richText',
      required: true,
    },
  ],
};

Builder.registerComponent(AllExperts, allExpertsConfig);
